import { TooltipComponent } from '../../context/Tutorial';
import { IStrategyAsset, TTickerCurrency } from '../../types/model';

import { CustomNumber } from '../CustomNumber/CustomNumber';
import { Title } from '../NewStrategy/Title';

import { getSymbol } from '../../helpers/functions';

import { Currency } from '../../types/common';
import { CurrencyCodeEnum } from '../../constants/enums';

export const AlignmentRow = ({
  currency = CurrencyCodeEnum.USD,
  asset: {
    asset: { name, history, logo, type },
    entryPrice,
    name: description,
    todo,
    unit,
  },
  checkBox,
  tooltipElement: Tooltip = () => <></>,
}: {
  asset: IStrategyAsset & { todo: 'BUY' | 'SELL' };
  currency?: Currency['code'];
  checkBox?: JSX.Element;
  tooltipElement?: TooltipComponent;
}) => {
  const price = history[0][currency.toLocaleLowerCase() as TTickerCurrency];

  const symbol = getSymbol(currency);

  return (
    <div
      className={`
      grid
      grid-cols-7
      items-center
      py-3
      border-b
      border-grey-10
      bg-grey-5
      dark:bg-grey-90
      dark:border-grey-70
    `}
    >
      {/* TITLE */}
      <span className="flex items-center gap-2 col-span-2 truncate pr-5">
        {checkBox}
        <Title
          className="ml-5"
          assetType={type}
          description={description}
          logo={logo}
          logoRadius="8"
          title={name}
        />
        <Tooltip tooltipPopupClassname="w-52" />
      </span>

      {/* TO DO */}
      <span className={`text-${todo === 'BUY' ? 'positive' : 'negative'}`}>
        {todo}
      </span>

      {/* QUANTITY */}
      <CustomNumber
        allowNegative={false}
        className="col-span-2 ml-6 bg-grey-5 dark:bg-grey-90"
        value={unit}
      />

      {/* TOTAL VALUE */}
      <CustomNumber
        allowNegative={false}
        className={`
          col-span-2
          ml-6
          bg-grey-5
          dark:bg-grey-90
          text-${todo !== 'BUY' ? 'positive' : 'negative'}
        `}
        prefix={todo !== 'BUY' ? '+' : '-'}
        suffix={symbol}
        value={unit * price}
      />
    </div>
  );
};
